import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Payment from "./pages/Payment";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/sonner";
import { TypeAnimation } from 'react-type-animation';

function App() {
  useEffect(() => {
    // Admin kullanıcısını kontrol et ve yoksa oluştur
    const mockUsers = JSON.parse(localStorage.getItem('mockUsers') || '[]');
    if (!mockUsers.find(u => u.role === 'admin')) {
      mockUsers.push({
        id: 999,
        name: 'Admin',
        email: 'admin@swenzy.com',
        password: 'admin123',
        role: 'admin'
      });
      localStorage.setItem('mockUsers', JSON.stringify(mockUsers));
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
